import { Locale } from '@ps-smart-cp/ppfw-client';

const registrationMethodClassConfig = {
  singleReg: new Map([[Locale.ja, '1件登録']]),
  dataImport: new Map([[Locale.ja, 'データ取込']]),
  multiReg: new Map([[Locale.ja, '複数選択登録']]),
  bulkInstr: new Map([[Locale.ja, '一括指示']]),
  incrDecrCancel: new Map([[Locale.ja, '増減取消']]),
};

export { registrationMethodClassConfig };
